import PropTypes from "prop-types";

export const CardPropType = PropTypes.shape({
  id: PropTypes.string,
  imgSrc: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  btnText: PropTypes.string,
  link: PropTypes.string,
});

export const CardGridPropType = PropTypes.shape({
  category: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cards: PropTypes.arrayOf(CardPropType),
  pageSize: PropTypes.number.isRequired,
});



// WEBPACK FOOTER //
// ./src/core/admin/components/CardGrid/misc/custom-prop-types.js